import localStorageAccess from './localStorageAccess';

const getAuthenticationHeader = (): { headers: HeadersInit } => {
  const jwtToken = localStorageAccess.getJwtToken();
  if (jwtToken != null) {
    return {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwtToken}`,
      },
    };
  }
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
};

const makeRequest = async <T>(url: string, method: 'GET' | 'POST' | 'DELETE', body?: string): Promise<T | null> => {
  const urlPrefix = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8080' : '';
  try {
    const headers = getAuthenticationHeader();
    const response = await fetch(`${urlPrefix}${url}`, {
      method,
      ...headers,
      ...(body != null ? { body } : {}),
    });
    if (response.status === 401) {
      const pathname = window.location.pathname;
      if (!pathname.includes('authentication')) {
        window.history.pushState(null, '', `/authentication?redirect=${pathname}`);
      }
    }
    if (response.status === 200) {
      return await response.json();
    }
  } catch (error) {
    // TODO
    console.log(error);
  }
  return null;
};

export default makeRequest;
